import Head from 'next/head';
import SVG from 'react-inlinesvg';
import { signIn } from 'next-auth/react';
import {
  AboutHeadingSectionStyle,
  AboutHeadingBackgroundStyle,
  AboutHeadingTextWrapperStyle,
  AboutMoreSectionStyle,
  AboutMoreDevicesStyle,
  AboutMoreTextStyle,
  AboutMoreCornerGradientStyle,
  AboutAccountSectionStyle,
  AboutAccountTitleStyle,
  AboutAccountTextWrapperStyle,
  AboutAccountBulletWrapperStyle,
  AboutAccountBulletStyle,
  AboutAccountButtonWrapperStyle,
  AboutAccountImageStyle,
  AboutInfoSectionStyle,
  AboutFaqStyle,
  AboutFaqTextStyle,
  AboutFaqButtonWrapperStyle,
  AboutAboutImageStyle,
  AboutAddressStyle,
  AboutMediadienstStyle,
  AboutAccountSeparatorWrapperStyle,
  AboutAccountSeparatorSvgStyle,
  AboutAccountSeparatorStyle,
  AboutAccountArrowWrapperStyle,
  AboutAccountArrowStyle
} from 'components/About/About.style';
import Link from 'components/Link';
import { Heading1, BodyText, BoldText } from 'components/Text/Text.style';
import ImageMedia from 'components/ImageMedia';
import { getStaticAsset } from 'lib/helpers/resources';
import Button from 'components/Button';
import { Grid, GridElement } from '../src/client/styles/grid';
import { ICONS, IMAGE_MEDIA_TYPE } from '../src/client/constants';

export const FreeAccountBenefits: { firstWord: string; restOfTheSentence: string }[] = [
  {
    firstWord: 'Kijklijst:',
    restOfTheSentence: ' bewaar je programma’s om later te kijken'
  },
  {
    firstWord: 'Verder kijken:',
    restOfTheSentence:
      ' zonder gedoe die aflevering afkijken waar je gebleven was op een ander moment op al je apparaten'
  },
  // {
  //   firstWord: 'Live:',
  //   restOfTheSentence: ' kijk gratis de allerbeste sportevents onder meer Europa League en Conference League'
  // },
  { firstWord: 'Altijd op de hoogte:', restOfTheSentence: ' van nieuwe programma’s en films' }
];

const About: React.FC<{}> = () => (
  <>
    <Head>
      <title>Over - KIJK opent je ogen</title>
    </Head>
    <div data-testid="about">
      <AboutHeadingSectionStyle data-testid="aboutHeadingSection">
        <AboutHeadingBackgroundStyle />
        <Grid>
          <AboutHeadingTextWrapperStyle data-testid="textFirstSection">
            <Heading1>Kijk lekker met KIJK</Heading1>
          </AboutHeadingTextWrapperStyle>
        </Grid>
      </AboutHeadingSectionStyle>
      <AboutMoreSectionStyle data-testid="aboutMoreSection">
        <AboutMoreCornerGradientStyle />
        <Grid>
          <GridElement lgColumn="1 / 7" mdColumn="1 / 13" smColumn="1 / 7">
            <AboutMoreDevicesStyle data-testid="aboutMoreDevicesStyle">
              <ImageMedia
                publicId={getStaticAsset('static/images/img-devices.png')}
                title="KIJK opent je ogen"
                imageMedia={{ type: IMAGE_MEDIA_TYPE.REMOTE }}
                shouldLazyLoad={false}
                transformations={{
                  width: '520',
                  crop: 'fill',
                  fetch_format: 'auto'
                }}
              />
            </AboutMoreDevicesStyle>
          </GridElement>
          <GridElement lgColumn="7 / 13" mdColumn="1 / 13" smColumn="1 / 7">
            <AboutMoreTextStyle data-testid="aboutMoreText">
              <Heading1>Kijk lekker naar….</Heading1>
              <br />
              <BodyText>
                …. al je favoriete programma’s van SBS6, Net5, Veronica en SBS9. Of naar programma’s van online merken
                zoals LINDA., StukTV en Gierige Gasten. Van misdaad tot actualiteit en van entertainment tot reality.
                Toegang tot livestreams van sportwedstrijden van Europa League en Conference League. Kijk wekelijks naar
                een nieuwe selectie populaire films. Er is altijd iets nieuws om te ontdekken op KIJK. Download de KIJK
                app en kijk lekker onderweg, thuis of met vrienden.
              </BodyText>
            </AboutMoreTextStyle>
          </GridElement>
        </Grid>
      </AboutMoreSectionStyle>
      <AboutAccountSectionStyle data-testid="aboutAccountSection">
        <Grid>
          <AboutAccountTextWrapperStyle>
            <AboutAccountTitleStyle data-testid="aboutAccountTitle">
              Haal meer uit KIJK met een gratis profiel:
            </AboutAccountTitleStyle>
            {FreeAccountBenefits.map(({ firstWord, restOfTheSentence }) => (
              <AboutAccountBulletWrapperStyle data-testid="aboutAccountBullet" key={restOfTheSentence}>
                <SVG src={ICONS.CHECK_DROPDOWN} />
                <AboutAccountBulletStyle data-testid="aboutAccountBulletStyle">
                  <BoldText>{firstWord}</BoldText>
                  {restOfTheSentence}
                </AboutAccountBulletStyle>
              </AboutAccountBulletWrapperStyle>
            ))}
            <AboutAccountButtonWrapperStyle>
              <Button onClick={() => signIn('talpaauth')} isActionButton>
                <span>Maak een gratis profiel aan</span>
                <AboutAccountSeparatorWrapperStyle>
                  <AboutAccountSeparatorStyle>
                    <AboutAccountSeparatorSvgStyle>
                      <img src={ICONS.SEPARATOR} alt="separator icon" />
                    </AboutAccountSeparatorSvgStyle>
                    <AboutAccountArrowWrapperStyle>
                      <AboutAccountArrowStyle />
                    </AboutAccountArrowWrapperStyle>
                  </AboutAccountSeparatorStyle>
                </AboutAccountSeparatorWrapperStyle>
              </Button>
            </AboutAccountButtonWrapperStyle>
          </AboutAccountTextWrapperStyle>
        </Grid>
        <AboutAccountImageStyle data-testid="aboutAccountImage" />
      </AboutAccountSectionStyle>
      <AboutInfoSectionStyle data-testid="aboutInfoSection">
        <Grid>
          <GridElement lgColumn="1 / 13" mdColumn="1 / 13" smColumn="1 / 7">
            <AboutFaqStyle data-testid="aboutFaq">
              <Heading1 align="center">Veelgestelde vragen</Heading1>
              <AboutFaqTextStyle data-testid="aboutFaqFirst">Heb je een vraag over KIJK?</AboutFaqTextStyle>
              <AboutFaqTextStyle data-testid="aboutFaqSecond">
                Vind je antwoord tussen de veelgestelde vragen.
              </AboutFaqTextStyle>
              <AboutFaqButtonWrapperStyle>
                <Link href="https://klantenservice.kijk.nl">Veelgestelde vragen</Link>
              </AboutFaqButtonWrapperStyle>
            </AboutFaqStyle>
          </GridElement>
          <GridElement lgColumn="1 / 7" mdColumn="1 / 7" smColumn="1 / 7">
            <AboutAddressStyle data-testid="aboutAdressInfo">
              Talpa TV
              <br />
              Rietlandpark 333
              <br />
              1019 DW Amsterdam
              <br />
              Telefoonnummer: +31 20 800 7000
              <br />
              KvK-nummer: 33268595
              <br />
              Btw-identificatienummer: NL8036.71.878.B.01
            </AboutAddressStyle>
          </GridElement>
          <GridElement lgColumn="7 / 13" mdColumn="7 / 13" smColumn="1 / 7">
            <AboutMediadienstStyle data-testid="aboutInfoImg">
              <AboutAboutImageStyle>
                <ImageMedia
                  publicId={getStaticAsset('static/images/img-mediadienst@3x.jpg')}
                  title="Mediadienst"
                  imageMedia={{ type: IMAGE_MEDIA_TYPE.REMOTE }}
                  shouldLazyLoad={false}
                  transformations={{
                    width: '234',
                    crop: 'fill',
                    fetch_format: 'auto'
                  }}
                />
              </AboutAboutImageStyle>
              <br />
              <br />
              Ten aanzien van het videogedeelte van KIJK is het Commissariaat voor de Media belast met het toezicht op
              de naleving van de Mediawet 2008.
            </AboutMediadienstStyle>
          </GridElement>
        </Grid>
      </AboutInfoSectionStyle>
    </div>
  </>
);

export default About;
